import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import LengthConverter from './components/LengthConverter';
import VolumeConverter from './components/VolumeConverter';
import TemperatureConverter from './components/TemperatureConverter';
import CurrencyConverter from './components/CurrencyConverter';
import WeightConverter from './components/WeightConverter';
import './App.css';

function App() {
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  return (
    <Router>
      <div className="app">
        <header>
          <h1>Conversion Tools Bundle</h1>
          <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle Dark Mode">
            {theme === 'light' ? '🌙' : '☀️'}
          </button>
          <nav>
            <Link to="/length">Length</Link>
            <Link to="/volume">Volume</Link>
            <Link to="/temperature">Temperature</Link>
            <Link to="/currency">Currency</Link>
            <Link to="/weight">Weight</Link>
          </nav>
        </header>
        <main>
          <Routes>
            <Route path="/length" element={<LengthConverter />} />
            <Route path="/volume" element={<VolumeConverter />} />
            <Route path="/temperature" element={<TemperatureConverter />} />
            <Route path="/currency" element={<CurrencyConverter />} />
            <Route path="/weight" element={<WeightConverter />} />
            <Route path="/" element={<LengthConverter />} />
          </Routes>
        </main>
        <footer>
          <p>Conversion Tools Bundle © {new Date().getFullYear()}</p>
          <p>A professional unit converter for all your needs</p>
          <p>
            <a href="/privacy-policy">Privacy Policy</a> | <a href="/terms-of-service">Terms of Service</a>
          </p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
